import Lang from './Lang'
import Swal from 'sweetalert2'

export default class FileInput {
    #element
    #outputElement

    constructor(element) {
        this.#element = element
        this.#outputElement = document.querySelector(element.dataset.gpTarget)

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new FileInput(element))
    }

    #bindEvents() {
        this.#element.addEventListener('change', () => {
            return this.#handleChange()
        })

        this.#element.addEventListener('clear', () => {
            return this.#handleChange()
        })
    }

    #handleChange() {
        if (this.#element.files.length === 0) {
            if (this.#outputElement) {
                this.#outputElement.innerText = ''
            }

            return true
        }

        let fileObject = this.#element.files[0]
        let maxSizeMb = this.#element.dataset.gpMaxSize ?? 8
        let maxSize = maxSizeMb * 1024 * 1024
        if (fileObject.size > maxSize) {
            Swal.fire({
                title: Lang.get('general.invalid_file'),
                text: Lang.get('general.file_too_large', { size: maxSizeMb }),
                icon: 'warning',
            })
            return false
        }

        if (this.#outputElement) {
            this.#outputElement.innerText = fileObject.name
        }

        this.#element.dispatchEvent(
            new CustomEvent('done', {
                detail: {
                    file: fileObject,
                },
            })
        )

        return true
    }
}
